import { useSelector } from "react-redux";
import Home from "../../qg-components/src/aws-pages/Home";
import Dropdown from "../../qg-components/src/libs/Dropdown/index";
import Avatar from "../../qg-components/src/libs/Avatar/index";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import Language from "./Language";

const AWSHome = ({ userInfo, navigation, basename, handleSignOut }) => {
  const [current, setCurrent] = useState("home");

  const [newNavigation, setNavigation] = useState([]);
  const language = useSelector((state) => state.language.language);
  // navigation, language 改变，改变sidebar显示
  useEffect(() => {
    setNavigation(navigation(language));
  }, [navigation, language]);


  useEffect(() => {
    setRoute();
    window.addEventListener("hashchange", setRoute);
    return () => window.removeEventListener("hashchange", setRoute);
  }, []);



  const setRoute = () => {
    const location = window.location.href.split("/");
    const pathname = location[location.length - 1];
    setCurrent(pathname ? pathname : "home");
  };

  const handleNameToAvatarAlt = (name) => {
    if (!name) return;
    let str = "";
    name
      .split(" ")
      .forEach((item) => (str += item.substring(0, 1).toUpperCase()));
    return str;
  };
  return (
    <>
      <Home
        navigation={newNavigation}
        basename={basename}
        topBarChildren={
          <div className="flex items-center">
            {/* 语言选择模块 */}
            <Language></Language>
            <Dropdown
              button={
                <Avatar avatarSrc="https://joeschmoe.io/api/v1/random">
                  {userInfo && handleNameToAvatarAlt(userInfo.username)}
                </Avatar>
              }
              direction="right-bottom"
            >
              <div className="px-4 py-3">
                <p className="text-sm">{userInfo && userInfo.username}</p>
                <p className="text-sm font-medium text-gray-900 truncate">
                  {userInfo && userInfo.email}
                </p>
              </div>
              <ul className="py-1">
                {/* Logout */}
                <NavLink
                  className="text-sm hover:bg-gray-100 text-gray-700 block px-4 py-2"
                  to={current}
                  onClick={handleSignOut}
                >
                  Sign out
                </NavLink>
              </ul>
            </Dropdown>
          </div>
        }
      ></Home>
    </>
  );
};

export default AWSHome;
